import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import useLocationStore from './locatonStore'; // Adjust the import as needed

interface BgColorState {
  bgColor: string;
  mainBgColor?: string;
  isDarkMode: boolean;
  textColor?: string;
  updateBgColor: () => void;
  updateMainBgColor: () => void;
  resetBgColor: () => void;
  resetMainBgColor: () => void;
  toggleTheme: () => void;
  clearBgColorStore: () => void;
}

const useBgColorStore = create<BgColorState>()(
  persist(
    (set, get) => ({
      bgColor: 'bg-cairns',
      isDarkMode: false,

      updateBgColor: () =>
        set((state) => {
          const ownerId = useLocationStore.getState().selectedLocation.OwnerId;
          const bgColor =
            ownerId === 1
              ? state.isDarkMode
                ? 'bg-locationColor'
                : 'bg-portduglas'
              : ownerId === 9
                ? state.isDarkMode
                  ? 'bg-locationColor'
                  : 'bg-cairns'
                : 'bg-portduglas'; // default fallback

          return { bgColor };
        }),

      updateMainBgColor: () =>
        set((state) => ({
          mainBgColor: state.isDarkMode
            ? 'bg-portduglasMainBg'
            : 'bg-foreground',
        })),

      resetBgColor: () =>
        set((state) => ({
          bgColor:
            state.bgColor === 'bg-cairns' ? 'bg-portduglas' : 'bg-cairns',
        })),

      resetMainBgColor: () =>
        set(() => ({
          mainBgColor: 'bg-portduglasMainBg',
        })),

      toggleTheme: () =>
        set((state) => {
          const isDark = !state.isDarkMode;
          const root = document.documentElement;
          if (isDark) root.classList.add('dark');
          else root.classList.remove('dark');

          return { isDarkMode: isDark };
        }),
      clearBgColorStore: () =>
        set({
          bgColor: 'bg-portduglas',
        }),
    }),
    {
      name: 'bg-color-storage',
      partialize: (state) => ({
        isDarkMode: state.isDarkMode,
      }),
      onRehydrateStorage: () => (state) => {
        if (state) {
          const root = document.documentElement;
          if (state.isDarkMode) root.classList.add('dark');
          else root.classList.remove('dark');

          const ownerId = useLocationStore.getState().selectedLocation.OwnerId;

          const bgColor =
            ownerId === 1
              ? state.isDarkMode
                ? 'bg-locationColor'
                : 'bg-portduglas'
              : ownerId === 9
                ? state.isDarkMode
                  ? 'bg-locationColor'
                  : 'bg-cairns'
                : 'bg-portduglas';

          const mainBgColor = state.isDarkMode
            ? 'bg-portduglasMainBg'
            : 'bg-foreground';

          state.bgColor = bgColor;
          state.mainBgColor = mainBgColor;
        }
      },
    },
  ),
);

export default useBgColorStore;
